/**
 * Page header script class
 *
 * @package    Components
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export default function Header(props) {
    const { children, title, ...other } = props;

    return (
        <div className="data-table-filters-wrap-block" {...other}>
            {title ? (
                <div className="data-table-title-block">
                    <FormattedMessage id={title} />
                </div>
            ) : (
                ''
            )}
            {children ? children : ''}
        </div>
    );
}

/**
 * @type {Object}
 */
Header.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx